import { render, staticRenderFns } from "./CustomAttributesEditDialog.vue?vue&type=template&id=8c98090e"
import script from "./CustomAttributesEditDialog.vue?vue&type=script&lang=ts"
export * from "./CustomAttributesEditDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports